<template>
  <v-layout>
    <v-dialog
      v-model="isVisible"
      persistent
      max-width="500"
    >
      <v-card>
        <table>
          <tr>
            <td class="dialogAccent" /><td>
              <div class="addUserDialog">
                <v-form
                  ref="newUserForm"
                  v-model="valid"
                  lazy-validation
                >
                  <v-text-field 
                    ref="userNameField"
                    v-model="userName"
                    class="dialogField"                        
                    :rules="userNameRules"
                    label="Username"
                    required
                  />
                  <br>
        
                  <v-text-field
                    v-model="firstName"
                    class="dialogField"
                    :rules="firstNameRules"
                    label="First Name"
                    required
                  />
                  <br>
        
                  <v-text-field
                    v-model="lastName"
                    class="dialogField"
                    :rules="lastNameRules"
                    label="Last Name"
                    required
                  />
                  <br>
        
                  <v-text-field
                    v-model="emailAddress"
                    class="dialogField"
                    :rules="emailAddressRules"
                    label="E-mail"
                    required
                  />
                </v-form>            
               

                <v-card-actions>
                  <div class="flex-grow-1" />
                  <v-btn
                    text
                    :disabled="!valid"
                    @click="saveUser"
                  >
                    Save
                  </v-btn>
                  <v-btn
                    text
                    @click="isVisible = false"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </div>
            </td>
          </tr>
        </table>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

import {mapActions, mapMutations } from "vuex";

export default {
    name: "NewUserDialog",     
    props: {       
        value:Boolean,
        psClientGuid:{
            type: String,
            required:true
        }
    },   
    data() {
        return {     
            valid: false,
            userName: "",
            userNameRules: [
                v => !!v || "Username is required",
                v => (v && v.length <= 50) || "Username must be less than 50 characters",
            ],
            firstName: "",
            firstNameRules: [
                v => !!v || "First Name is required",
                v => (v && v.length <= 50) || "First Name must be less than 50 characters",
            ],
            lastName: "",
            lastNameRules: [
                v => !!v || "Last Name is required",
                v => (v && v.length <= 50) || "Last Name must be less than 50 characters",
            ],
            emailAddress: "",
            emailAddressRules: [
                v => !!v || "E-mail is required",
                v => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],      
        };
    },
    computed: {
        isVisible: {
            get () {return this.value;},
            set (value) {               
                this.$emit("input", value); 
            }
        }
    },
    methods: {        
        ...mapActions(["addUser"]),        
        saveUser() {     
            if (this.$refs.newUserForm.validate()) {

                const user = {
                    PsClientGuid: this.psClientGuid,
                    Guid: "{00000000-0000-0000-0000-000000000000}",
                    UserName: this.userName,
                    FirstName: this.firstName,
                    LastName: this.lastName,
                    Email:this.emailAddress               

                }; 
                this.addUser(user);   
                this.isVisible=false;    
            }                       
        },        
        clearForm() {
            this.$refs.newUserForm.reset(); 
        },
        setFocus() {
            this.$refs.userNameField.focus();       
        }
    }
};
</script>

<style scoped lang='scss'>
    //freezes on build if uncommented - added styles to parent component
   // @import "../styles/NewUserDialog.scss";
</style>